import React from 'react'

import SinglePageNavbar from '../components/single-page-navbar'
import Feature from '../components/feature'
import AboutOne from '../components/about-one'
import Client from '../components/client'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
import HomeBanner from '../components/home-banner'
import Market from '../components/market'
import App from '../components/app'

export default function Onepage() {
  return (
    <>
    <SinglePageNavbar/>

    <HomeBanner/>

    <section className="section bg-light">
        <div className="container">
            <AboutOne/>
        </div>
    </section>

    <section className="section" id="cryptocurrency">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-12">
                    <div className="section-title text-center mb-4 pb-2">
                        <h4 className="title mb-3">Cryptocurrency Market</h4>
                        <p className="text-muted para-desc mx-auto mb-0">Our platform reaches people all over the world, hereby we are trusted as the best platform for crypto trading.</p>
                    </div>
                </div>
            </div>
            <Market/>
        </div>
    </section>

    <section className="section bg-light" id="trader">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-12">
                    <div className="section-title text-center mb-4 pb-2">
                        <h4 className="title mb-3">Become a Crypto Trader</h4>
                        <p className="text-muted para-desc mx-auto mb-0">Our platform reaches people all over the world, hereby we are trusted as the best platform for crypto trading.</p>
                    </div>
                </div>
            </div>
            <Feature/>
        </div>
    </section>

    <section className="section" id="testimonial">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-12">
                    <div className="section-title text-center mb-4 pb-2">
                        <h4 className="title mb-3">Customer's Review</h4>
                        <p className="text-muted para-desc mx-auto mb-0">Our platform reaches people all over the world, hereby we are trusted as the best platform for crypto trading.</p>
                    </div>
                </div>
            </div>
            <Client/>
        </div>
    </section>

    <section className="section bg-light" id="application">
        <div className="container">
            <App/>
        </div>
    </section>

    <Footer/>

    <ScrollToTop/>
    </>
  )
}
